import Vue from 'vue'
// import axios from 'axios'
// import store from '../../store';
import axios from '@/wrappers/axios.js'

const releaseService = {

    releaseList(params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/releases${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    createRelease(data) {
        return new Promise(async (resolve, reject) => {
            axios
                .post(`/releases`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    getRelease(id) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/releases/${id}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    updateRelease(id, data) {
        return new Promise(async (resolve, reject) => {
            axios
                .put(`/releases/${id}`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
    releaseAsOptions(data) {
        return new Promise(async (resolve, reject) => {
            axios
                .post(`/releases/options`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    }
}

Vue.$releaseService = releaseService

export default releaseService